import { useState } from 'react';

import type { ClientId } from '@nesso/ledger-contracts/ids';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@nesso/ui/primitives/dialog';

import type { SessionCharge } from '@/entities/session-charge';

import { EditSessionFeeDialogForm } from './edit-session-fee-dialog/edit-session-fee-dialog-form';

type Props = {
    clientId: ClientId;
    sessionCharge: SessionCharge | null;
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

export function EditSessionFeeDialog({ clientId, sessionCharge, open, onOpenChange }: Props) {
    const [pending, setPending] = useState(false);

    function handleOpenChange(next: boolean) {
        if (pending) return;
        onOpenChange(next);
    }

    if (!sessionCharge) return null;

    return (
        <Dialog open={open} onOpenChange={handleOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Edit fee</DialogTitle>
                </DialogHeader>
                <EditSessionFeeDialogForm
                    clientId={clientId}
                    sessionCharge={sessionCharge}
                    onClose={() => onOpenChange(false)}
                    onPendingChange={setPending}
                />
            </DialogContent>
        </Dialog>
    );
}
